/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { AccordionExpandCollapse } from "cms/components/accordion/expand_collapse";
import { AccordionSection } from "cms/components/accordion/accordion_section";
import { isArrayNotEmpty } from "cms/utils/empty-exists";
import { cloneArray } from "cms/hooks/helpers/hooks-helpers";

const AccordionComponent = (props) => {

    const component = props?.component;
    const guid = component?.guid;
    const showSteps = component?.showSteps ?? false;
    const initialSections = component.sections || [];

    const [sections, setSections] = useState(initialSections);
    const [allOpen, setAllOpen] = useState(false);
    const [allClosed, setAllClosed] = useState(true);

    useEffect(() => {
        if (isArrayNotEmpty(sections)) {
            // if every section is open, set allOpen=true
            const _allOpen = sections.every((section) => section.isVisible);
            setAllOpen(_allOpen);
            // if every section is closed, set allClosed=true
            const _allClosed = sections.every((section) => !section.isVisible);
            setAllClosed(_allClosed);
        }
    }, [sections]);

    const selectSection = function (tab_id, event) {
        event.preventDefault();
        const _sections = cloneArray(sections);
        _sections.forEach((section) => {
            if (section.tab_id === tab_id) {
                section.isVisible = !section.isVisible;
            }
        });
        setSections(_sections);
    };
    const expandAllSections = function (event) {
        event.preventDefault();
        const _sections = cloneArray(sections);
        _sections.forEach((section) => {
            section.isVisible = true;
        });
        setSections(_sections);
    };
    const collapseAllSections = function (event) {
        event.preventDefault();
        const _sections = cloneArray(sections);
        _sections.forEach((section) => {
            section.isVisible = false;
        });
        setSections(_sections);
    };

    return (
        <div className="simplicity-accordion-container">
            <div className="simplicity-accordion-content">
                <div className="simplicity-accordion-heading">
                    <h2>{component && component.title}</h2>
                    <p>{component && component.description}</p>
                </div>
                <AccordionExpandCollapse
                    allClosed={allClosed}
                    allOpen={allOpen}
                    expandAllSections={expandAllSections}
                    collapseAllSections={collapseAllSections}
                />
                <div
                    className={"simplicity-accordion-root"}
                    data-group-type="accordion"
                    role="tablist"
                    aria-multiselectable="true"
                >

                    {showSteps && (
                        <div className="line" >
                            <span />
                        </div>
                    )}

                    {sections &&
                        sections.map((section, index) => (
                            <AccordionSection
                                section={section}
                                group_id={guid}
                                selectSection={selectSection}
                                key={section.guid}
                                tabIndex={index}
                                stepNumber={index + 1}
                                showSteps={showSteps}
                            />
                        ))}
                </div>
            </div>
        </div>
    );
};

AccordionComponent.displayName = "AccordionComponent";
export { AccordionComponent };
